import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Dialog, IconButton, Rating, Stack, Typography, } from '@mui/material';
import { Close, StarOutline } from 'mdi-material-ui';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import FeedbackForm from './FeedbackForm';
const FeedbackDialog = ({ title, value, data, onSubmitFeedback, disabled = false, }) => {
    const [open, setOpen] = useState(false);
    const editable = typeof value !== 'undefined';
    const menuItems = title === 'Media Plan'
        ? [
            {
                key: 'campaignBrief',
                displayName: 'Campaign Brief',
                tooltip: 'weightage 1 star out of 5 stars',
            },
            {
                key: 'competitionAndMedia',
                displayName: 'Competition and Media',
                tooltip: 'weightage 1 star out of 5 stars',
            },
            {
                key: 'systemRecommendation',
                displayName: 'System Recommendation',
                tooltip: 'weightage 1 star out of 5 stars',
            },
            {
                key: 'plannerRecommendation',
                displayName: 'Planner Recommendation',
                tooltip: 'weightage 2 stars out of 5 stars',
            },
        ]
        : [
            {
                key: 'aboutBrand',
                displayName: 'About Brand',
                tooltip: 'weightage 1.5 stars out of 5 stars',
            },
            {
                key: 'campaignDetails',
                displayName: 'Campaign Details',
                tooltip: 'weightage 1.5 stars out of 5 stars',
            },
            {
                key: 'targetAudience',
                displayName: 'Target Audience',
                tooltip: 'weightage 1 stars out of 5 stars',
            },
            {
                key: 'mediaPreferences',
                displayName: 'Media Preferences',
                tooltip: 'weightage 0.5 stars out of 5 stars',
            },
            {
                key: 'mediaSpecificDetails',
                displayName: 'Media Specific Details',
                tooltip: 'weightage 0.5 stars out of 5 stars',
            },
        ];
    const [selectedMenuItem, setSelectedMenuItem] = useState(title === 'Media Plan' ? 'campaignBrief' : 'aboutBrand');
    const { control, handleSubmit } = useForm({
        defaultValues: Object.assign({}, data),
    });
    const onSubmit = (data) => onSubmitFeedback(data);
    return (_jsxs(_Fragment, { children: [typeof value !== 'undefined' ? (_jsx(Button, Object.assign({ onClick: () => setOpen(true), sx: { padding: '0px !important' } }, { children: _jsx(Rating, { value: value, size: "small", precision: 0.5, readOnly: true }) }))) : (_jsx(Button, Object.assign({ sx: { fontWeight: 600, fontSize: '14px', padding: '0px !important' }, onClick: () => setOpen(true), disabled: disabled, startIcon: _jsx(StarOutline, { sx: {
                        width: '20px',
                        height: '20px',
                        color: disabled ? '#dedede' : 'primary.main',
                    } }) }, { children: `Rate ${title}` }))), _jsxs(Dialog, Object.assign({ open: open, onClose: () => setOpen(false), PaperProps: {
                    sx: {
                        maxWidth: '748px',
                        width: '748px',
                        borderRadius: '8px',
                    },
                } }, { children: [_jsxs(Box, Object.assign({ sx: {
                            padding: '32px',
                            background: 'linear-gradient(93deg, #F0EEFF 0.24%, #E6E2FF 98.54%)',
                        } }, { children: [_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Typography, Object.assign({ variant: "h1", fontWeight: 500 }, { children: ` How would you rate your experience with ${title}?` })), _jsx(IconButton, Object.assign({ onClick: () => setOpen(false), color: "primary" }, { children: _jsx(Close, {}) }))] })), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "Thank You! We read every feedback we get and we take it very seriously" }))] })), _jsxs("form", Object.assign({ onSubmit: handleSubmit(onSubmit) }, { children: [menuItems.map((item, index) => {
                                if (item.key === selectedMenuItem)
                                    return (_jsx(FeedbackForm, { editable: editable, selectedMenuItem: selectedMenuItem, setSelectedMenuItem: setSelectedMenuItem, menuItems: menuItems, control: control, data: data }, index));
                            }), !editable && (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "flex-end", p: '0px 24px 32px 24px', spacing: 4 }, { children: [_jsx(Button, Object.assign({ onClick: () => setOpen(false), variant: "outlined", sx: {
                                            fontWeight: 500,
                                            padding: '8px 60px',
                                            border: '2px solid #4E3BC9',
                                            '&:hover': { border: '2px solid #4E3BC9' },
                                        } }, { children: "Cancel" })), _jsx(Button, Object.assign({ type: "submit", variant: "contained", sx: { fontWeight: 500, padding: '10px 60px' } }, { children: "Submit" }))] })))] }))] }))] }));
};
export default FeedbackDialog;
